/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse | undefined,
  CancelInvoice: (params: vp.RailzInvoiceCancelRequest) => void,
  CancelInvoiceAsync: (params: vp.RailzInvoiceCancelRequest) => Promise<vp.ApiResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCancelInvoice: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCancelRequest, setShouldCancelRequest] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.RailzInvoiceCancelRequest>({
    InvoiceRefID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>();

  useEffect(() => {
    if (!shouldCancelRequest) return () => {};

    const PostCancel = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCancelInvoice(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCancelRequest) void PostCancel();
    setShouldCancelRequest(false);
    return () => {
      source.cancel();
    };
  }, [shouldCancelRequest]);

  return [
    response,
    (_params: vp.RailzInvoiceCancelRequest) => {
      setParams(_params);
      setShouldCancelRequest(true);
    },
    (_params: vp.RailzInvoiceCancelRequest) => {
      const res = api.postCancelInvoice(_params, source);
      return res;
    },
    () => {
      setResponse(undefined);
      setShouldCancelRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCancelInvoice);
